<template>
  <div class="ml-auto items-center">
    <ThemeToggle />
  </div>
</template>

<script setup lang="ts">
import ThemeToggle from '../../common-components/ThemeToggle.vue';
</script>
